module.exports = __webpack_public_path__ + "fe539ef4cdd86db064a12dfd05f7aa66.png";